import { render } from "./InquiryAnswerForm.vue?vue&type=template&id=1cc56dcc&lang=true"
import script from "./InquiryAnswerForm.vue?vue&type=script&lang=js"
export * from "./InquiryAnswerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__